import {Component} from 'react'
import { Container, Row } from 'reactstrap';
import CarouselMobile from '../Hebergement/carouselMobile';

export default class HeadMobile extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return (
          <>
            {/* Header mobile carousel */}
            <div className="head-mobile d-xs-block d-md-none">
              <Container className="mobile-view-search-bar">
                <Row>
                  <div className="logo-mobile-view">
                    <img
                      src="imgs/logo/Group_83.svg"
                      alt="lightLogo"
                      className="logo-mobile"
                    />
                  </div>
                </Row>
                <center id="under-logo-mobile">
                  <span>Trouver Le bonheur</span>
                </center>
              </Container>
              <div className="carousel">
                <CarouselMobile />
              </div>
            </div>
          </>
        );
    }
}
 